<template>
  <v-btn
    type="submit"
    :block="block"
    :disabled="loading || disabled"
    :color="successState ? 'success' : color"
    :data-cy="dataCy"
    :width="width"
    @click="$emit('click')"
  >
    <div v-if="loading">
      <!-- if statement must be in parent div, otherwise lottieAnimation does not update on property update-->
      <LottieAnimation
        ref="animLoading"
        :animation-data="$asset('animations/ekg.json')"
        :loop="true"
        :auto-play="true"
        :speed="1"
        class="lottie_animation mr-2"
      />
    </div>
    <div v-if="successState">
      <LottieAnimation
        ref="animSuccess"
        :animation-data="$asset('animations/success.json')"
        :loop="false"
        :auto-play="true"
        :speed="1"
        class="lottie_animation mr-2"
      />
    </div>
    {{ sendButtonText }}
  </v-btn>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'SendButton',
  components: {
    LottieAnimation
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    successState: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: false
    },
    buttonTextLoading: {
      type: String,
      required: false
    },
    buttonTextSuccess: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataCy: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    }
  },
  computed: {
    sendButtonText() {
      if (this.loading) {
        return (
          this.buttonTextLoading || (!this.buttonText ? this.$t('sendProcess') : this.buttonText)
        );
      }
      if (this.successState) {
        return (
          this.buttonTextSuccess || (!this.buttonText ? this.$t('sendSuccess') : this.buttonText)
        );
      }
      return this.buttonText || this.$t('send');
    },
    resetTimeout: {
      get() {
        return this.$store.state.sendButton.resetTimeout;
      },
      set(value) {
        this.$store.dispatch('sendButton/setResetTimeout', value);
      }
    }
  },
  watch: {
    successState(newValue) {
      if (newValue) {
        this.resetTimeout = setTimeout(() => {
          this.$emit('reset');
        }, 5000);
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.resetTimeout);
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  cursor: not-allowed !important;
}

.lottie_animation {
  width: 24px;
  height: 24px;
}
</style>
